import baseWs from '../generic/baseWs'
import _ from 'lodash';

export function fetchPermissions(roleName,option){
    return baseWs.post('/api/services/app/rolePermission/Fetch'+option+'Permissions', { 
        roleName: roleName
     })
     .then(res => {
         return res;
     })
     .catch(err => {
         if (!_.isEmpty(err.response)){
             console.log('Error')
         }
         console.log('Error getting permissions data: ' + err);
         throw err;
     })
}

export function insertRoles(record){
    return baseWs.post('/api/services/app/genericScreen/InsertRecord', { ...record	
    })
     .then(res => {
         return res;
     })
     .catch(err => {
         if (!_.isEmpty(err.response)){
             console.log('Error')
         }
         console.log('Error updating roles data: ' + err);
         throw err;
     })
}

export function updateRoles(record){
    return baseWs.post('/api/services/app/genericScreen/UpdateRecord', { ...record	
    })
     .then(res => {
         return res;
     })
     .catch(err => {
         if (!_.isEmpty(err.response)){
             console.log('Error')
         }
         console.log('Error updating roles data: ' + err);
         throw err;
     })
}

//Uploads everything displayed as part of the 
export function updatePermissions(record){
    return baseWs.post('/api/services/app/rolePermission/UpdatePermissions', [ ...record	
    ])
     .then(res => {
         return res;
     })
     .catch(err => {
         if (!_.isEmpty(err.response)){
             console.log('Error')
         }
         console.log('Error updating roles permissions data: ' + err);
         throw err;
     })
}

export function deleteRole(record){
    return baseWs.post('/api/services/app/genericScreen/DeleteRecord', { ...record	
    })
     .then(res => {
         return res;
     })
     .catch(err => {
         if (!_.isEmpty(err.response)){
             console.log('Error')
         }
         console.log('Error deleting role data: ' + err);
         throw err;
     })
}